module.exports = __webpack_public_path__ + "static/media/loader-image.bb5142a6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/loader-image.gif
// module id = 630
// module chunks = 0